import React, { useEffect, useMemo, useState } from 'react';
import styles from './SendEmail.module.scss';
import TextField from '@material-ui/core/TextField';

import { makeStyles } from '@material-ui/core/styles';
import { Button, CircularProgress, TextareaAutosize } from '@material-ui/core';
import ChipInput from 'material-ui-chip-input';
import _, { filter } from 'lodash';
import sendEmails from '../../api/SendEmails/sendEmails.api';

import './ckEditor/CkEditor.scss';
import { connect } from 'react-redux';
import getClientEmails from '../../api/SendEmails/getClientEmails.api';
import { useDropzone } from 'react-dropzone';
import MyDropzone from './dropzone/MyDropzone';
import MyCkEditor from './ckEditor/MyCkEditor';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import Modal from '../layout/modal/Modal';
import LeadsForm from './forms/LeadsForm';
import addLeads from '../../api/SendEmails/addLeads.api';
import getAllLeadsEmails from '../../api/SendEmails/getAllLeadsEmails.api';
import SelectBox from './selectBox/SelectBox';
import { onlyUnique } from '../../utils/onlyUniqueArrays';
import getAllSalesAgents from '../../api/SendEmails/getAllSalesAgents.api';
import AssignLead from './assignLead/AssignLead';

const SendEmail = ({ user }) => {
	const [emails, setEmails] = useState([]);
	const [ccEmails, setCcEmails] = useState([]);
	const [bodyText, setBodyText] = useState('');
	const [formData, setFormData] = useState({
		subject: '',
		clientFName: '',
		clientEmail: '',
		clientPhoneNumber: '',
		city: '',
		postalCode: '',
	});
	const [emailList, setEmailList] = useState();
	const [thisFiles, setThisFiles] = useState();
	const [leadModal, setLeadModal] = useState(false);
	const [assignLeadModal, setAssignLeadModal] = useState(false);
	const [leadEmails, setLeadEmails] = useState();
	const [selectedEmailInput, setSelectedEmailInput] = useState('');
	const [loading, setLoading] = useState(false);
	const [uniqueEmails, setUniqueEmails] = useState();
	const [uniqueCcEmails, setUniqueCcEmails] = useState();
	const [alert, setAlert] = useState('');
	const [salesAgents, setSalesAgents] = useState();
	const [filteredLeadEmails, setFilteredLeadEmails] = useState();

	const {
		acceptedFiles,
		getRootProps,
		getInputProps,
		isDragActive,
		isDragAccept,
		isDragReject,
	} = useDropzone({
		accept: 'image/*,.pdf',
	});

	useEffect(() => {
		setLoading(true);
		getClientEmails(user.uid, (returned) => setEmailList(returned));
		getAllLeadsEmails((returned) => setLeadEmails(returned));
		setLoading(false);
	}, []);

	useEffect(() => {
		setThisFiles(acceptedFiles);
		console.log('acceptedFiles', acceptedFiles);
	}, [acceptedFiles]);

	useEffect(() => {
		setUniqueEmails(emails?.filter(onlyUnique));
	}, [emails]);

	useEffect(() => {
		setUniqueCcEmails(ccEmails?.filter(onlyUnique));
	}, [ccEmails]);

	const {
		subject,
		clientFName,
		clientEmail,
		clientPhoneNumber,
		city,
		postalCode,
	} = formData;

	const useStyles = makeStyles(() => ({
		root: {
			minWidth: '30em',
			maxWidth: '30em',
			marginTop: '2em',
			backgroundColor: '#fff',
		},
	}));

	const classes = useStyles();

	const onChange = (e) => {
		setFormData({ ...formData, [e.target.name]: e.target.value });
	};

	//add emails
	const handleAddEmails = async (chip) => {
		setEmails([...emails, chip]);
	};

	// Delete emails
	const handleDeleteEmail = (chip) => {
		setEmails(_.without(emails, chip));
	};

	//add cc emails
	const handleAddCCEmails = (chip) => {
		setCcEmails([...ccEmails, chip]);
	};

	// Delete cc emails
	const handleDeleteCcEmail = (chip) => {
		setCcEmails(_.without(ccEmails, chip));
	};

	const handleSendEmail = (e) => {
		e.preventDefault();
		try {
			setLoading(true);
			var emailObj = {
				emails: emails,
				ccEmails: ccEmails,
				subject: subject,
				body: bodyText,
				attachments: thisFiles,
			};
			sendEmails(emailObj, (returned) => setLoading(returned));
			setEmails();
			setCcEmails();
			setFormData({
				subject: '',
				clientFName: '',
				clientEmail: '',
				clientPhoneNumber: '',
				city: '',
				postalCode: '',
			});
			setThisFiles();
			setAlert('Email successfully sent');
			setTimeout(() => {
				setAlert('');
			}, 3000);
		} catch (error) {
			setAlert('Error in sending mail - ' + error);
			setTimeout(() => {
				setAlert('');
			}, 3000);
		}
	};

	const remove = (file) => {
		const newFiles = [...thisFiles]; // make a var for the new array
		newFiles.splice(file, 1); // remove the file from the array
		setThisFiles(newFiles); // update the state
	};

	const files = thisFiles?.map((file, i) => (
		<div className={styles.list_files}>
			<li key={file.path}>
				{file.path} - {file.size} bytes -
			</li>
			<div className={styles.remove_button} onClick={() => remove(i)}>
				{' '}
				x{' '}
			</div>
		</div>
	));

	const baseStyle = {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: '20px',
		borderWidth: 2,
		borderRadius: 2,
		borderColor: '#eeeeee',
		borderStyle: 'dashed',
		backgroundColor: '#fafafa',
		color: '#bdbdbd',
		outline: 'none',
		transition: 'border .24s ease-in-out',
	};

	const style = useMemo(
		() => ({
			...baseStyle,
		}),
		[isDragActive, isDragReject, isDragAccept]
	);

	const handleLeads = () => {
		addLeads(user.uid, clientFName, clientEmail, clientPhoneNumber);
		handleCloseLeads();
	};

	const handleCloseLeads = () => {
		setLeadModal(false);
		setAssignLeadModal(false);
	};

	const handleSelectEmail = (e) => {
		var email = e.currentTarget.dataset.email;

		console.log('email', email);

		if (selectedEmailInput === 'email') {
			setEmails([...emails?.filter(onlyUnique), email]);
		} else if (selectedEmailInput === 'ccEmail') {
			setCcEmails([...ccEmails, email]);
		} else {
			setEmails([...emails, email]);
		}
	};

	const handleSelectAllEmails = () => {
		if (selectedEmailInput === 'email') {
			setEmails([...emails, ...filteredLeadEmails]);
		} else if (selectedEmailInput === 'ccEmail') {
			setCcEmails([...ccEmails, ...filteredLeadEmails]);
		} else {
			setEmails([...emails, ...filteredLeadEmails]);
		}
	};

	return (
		<>
			{loading && (
				<div className='loading_layout'>
					<CircularProgress
						style={{ position: 'fixed', left: '50%', top: '50%' }}
					/>
				</div>
			)}
			<div className={styles.send_email_page}>
				<h1 className={styles.title}>Send Email</h1>
				{alert && <p className={styles.alert_message}>{alert}</p>}
				<div className={styles.flex_email_and_select}>
					<form
						onSubmit={handleSendEmail}
						className={styles.leads_form}
						method='POST'
					>
						<div className={styles.email_form}>
							<ChipInput
								onAdd={(chip) => handleAddEmails(chip)}
								onDelete={(chip) => handleDeleteEmail(chip)}
								value={uniqueEmails}
								className={classes.root}
								variant='outlined'
								label='Emails (Press enter to enter multiple emails)'
								placeholder='user@email.com'
								onFocus={() => setSelectedEmailInput('email')}
							/>

							<ChipInput
								onAdd={(chip) => handleAddCCEmails(chip)}
								onDelete={(chip) => handleDeleteCcEmail(chip)}
								value={uniqueCcEmails}
								className={classes.root}
								variant='outlined'
								label='CC: Emails (Press enter to enter multiple emails)'
								placeholder='user@email.com'
								onFocus={() => setSelectedEmailInput('ccEmail')}
							/>
							<TextField
								className={classes.root}
								label='Subject'
								name='subject'
								value={subject}
								onChange={(e) => onChange(e)}
								variant='outlined'
								required
							/>
							<div className={classes.root}>
								<MyCkEditor
									bodyText={bodyText}
									setBodyText={setBodyText}
								/>
							</div>
							<label className={styles.attachment_label}>
								Attachments
							</label>
							<div className={classes.root}>
								<MyDropzone
									style={style}
									getRootProps={getRootProps}
									getInputProps={getInputProps}
								/>
							</div>
							<div className={styles.files_uploaded}>
								<h4>Files</h4>
								<ul>{files}</ul>
							</div>
							<div className='button_group'>
								<Button
									className={styles.send_email_btn}
									variant='contained'
									color='primary'
									type='submit'
								>
									Send Email
								</Button>
								<Button
									className={styles.add_leads_btn}
									variant='outlined'
									color='primary'
									onClick={() => {
										setLeadModal(true);
										getAllSalesAgents().then((returned) => {
											setSalesAgents(returned);
										});
									}}
								>
									Add lead
								</Button>
								<Button
									className={styles.assign_lead_btn}
									variant='outlined'
									color='primary'
									onClick={() => {
										setAssignLeadModal(true);
										getAllSalesAgents().then((returned) => {
											setSalesAgents(returned);
										});
									}}
								>
									Assign lead
								</Button>
							</div>
						</div>
					</form>
					<div className={styles.select_box_wrapper}>
						<div className={styles.select_box_header}>
							<h2>Select Emails</h2>
							<p
								className={styles.select_all}
								onClick={handleSelectAllEmails}
							>
								Select all emails
							</p>
						</div>
						<SelectBox
							leadEmails={leadEmails}
							handleSelectEmail={handleSelectEmail}
							setFilteredLeadEmails={setFilteredLeadEmails}
						/>
					</div>
				</div>
				<Modal
					show={leadModal}
					button={handleLeads}
					title='Add Leads'
					close={handleCloseLeads}
				>
					<LeadsForm
						handleCloseLeads={handleCloseLeads}
						source='portal'
						salesAgents={salesAgents}
					/>
				</Modal>
				<Modal
					show={assignLeadModal}
					button={handleLeads}
					title='Assign Lead'
					close={handleCloseLeads}
				>
					<AssignLead
						salesAgents={salesAgents}
						leadEmails={leadEmails}
						handleCloseLeads={handleCloseLeads}
					/>
				</Modal>
			</div>
		</>
	);
};

const mapStateToProps = (state) => ({
	user: state.signIn,
});

export default connect(mapStateToProps)(SendEmail);
